import { AuthHook } from '@interfaces/auth.interfaces';
import useAuthStore from '@stores/auth.store';
import {
	bootstrapAuth,
	clearAuthSession,
	markPostLogout,
	resetAuthBootstrap,
} from '@auth/bootstrap-auth';
import { getAccessToken, getAppRedirectUri, loginWithGoogle, logoutKeycloak } from '@auth/keycloak';
import useFirebase from './firebase.hook';

function useAuth(): AuthHook {
	async function initialize(): Promise<void> {
		await bootstrapAuth();
	}

	async function logout(event?: { preventDefault(): void }): Promise<void> {
		event?.preventDefault();

		markPostLogout();
		clearAuthSession();
		resetAuthBootstrap();

		try {
			await logoutKeycloak();
		} catch (error) {
			console.error('Error en logout Keycloak', error);
			window.location.assign(getAppRedirectUri());
		}
	}

	return {
		getAccessToken,
		getEmail: () => useAuthStore.getState().user?.email,
		getFullName: () => useAuthStore.getState().user?.fullName,
		getMenu: (id) => useAuthStore.getState().menus[id],
		initialize,
		isLoading: () => useAuthStore.getState().loading,
		isLogged: () => {
			const state = useAuthStore.getState();
			return state.token != null && state.user != null;
		},
		loginWithGoogle: () => loginWithGoogle(false),
		logout,
	};
}

/** Hook para arrancar Firebase tras auth (usado en App). */
export function useAuthBootstrap(): {
	initializeFirebaseAfterAuth: () => Promise<void>;
} {
	const { initialize: initializeFirebase } = useFirebase();

	async function initializeFirebaseAfterAuth(): Promise<void> {
		const state = useAuthStore.getState();
		if (state.token && state.user) {
			await initializeFirebase();
		}
	}

	return { initializeFirebaseAfterAuth };
}

export default useAuth;
